import { render, staticRenderFns } from "./PayDetail.vue?vue&type=template&id=51be3be1&scoped=true&"
import script from "./PayDetail.vue?vue&type=script&lang=js&"
export * from "./PayDetail.vue?vue&type=script&lang=js&"
import style0 from "./PayDetail.vue?vue&type=style&index=0&id=51be3be1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be3be1",
  null
  
)

export default component.exports